// // File: src/pages/CartPage.tsx

// import React from 'react';
// import { useCart } from "../Header/CartContext";
// import { useNavigate } from "react-router-dom";
// import { Trash2, CheckCircle, ShoppingCart } from "lucide-react";


// const CartPage = () => {
//   const { cart, updateQuantity, removeFromCart } = useCart();
//   const navigate = useNavigate();

//   const discount = 10;
//   const totalProductPrice = cart.reduce((acc, item) => acc + item.price * item.quantity, 0);
//   const grandTotal = totalProductPrice - discount;

//   const handleContinueToCheckout = () => {
//     localStorage.removeItem('buyNowProduct');
//     localStorage.removeItem('checkoutMode');
//     navigate("/checkoutpage");
//   };

//   if (cart.length === 0) {
//     return (
//       <div className="min-h-screen flex flex-col items-center justify-center text-center p-8"> 
//         <img src="/empty.jpg" alt="Empty Cart" className="w-60 mb-6" />
//         <h2 className="text-3xl font-semibold text-gray-800">
//           Your Cart is <span className="text-red-500">Empty!</span>
//         </h2>
//         <button
//           onClick={() => navigate('/')}
//           className="mt-6 bg-purple-600 text-white px-8 py-3 rounded-lg text-xl font-semibold hover:bg-purple-700 transition-colors shadow-lg"
//         >
//           Start Shopping
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="container mx-auto p-4 md:p-8 min-h-screen bg-gray-50">
//       <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">Your Shopping Cart</h1>
      
//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//         {/* Left Column: Cart Items */}
//         <div className="lg:col-span-2 space-y-4">
//           <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm border border-gray-100">
//             <h2 className="text-lg font-bold text-gray-800 mb-4">Items in your cart</h2>
            
//             <div className="divide-y divide-gray-100">
//               {cart.map((item) => (
//                 <div key={item.productId} className="py-6 first:pt-0 last:pb-0">
//                   {/* Item Layout */}
//                   <div className="flex flex-col sm:flex-row gap-4">
//                     {/* Image Section */}
//                     <div className="w-full sm:w-32 h-32 flex-shrink-0">
//                       <img
//                         src={item.imageUrl || '/Logo/default-product.png'}
//                         alt={item.productName}
//                         className="w-full h-full object-contain rounded-lg border border-gray-50"
//                       />
//                     </div>

//                     {/* Content Section */}
//                     <div className="flex-grow flex flex-col justify-between">
//                       <div>
//                         <h3 className="text-base md:text-lg font-medium text-gray-900 leading-tight">
//                           {item.productName}
//                         </h3>
//                         <p className="text-sm text-gray-500 mt-1">Seller: {item.seller || 'N/A'}</p>
//                         <p className="text-lg font-bold text-gray-800 mt-2">₹{item.price.toFixed(2)}</p>
//                       </div>

//                       {/* Controls Section: Mobile pe niche, Desktop pe side me */}
//                       <div className="flex items-center justify-between mt-4 sm:mt-0">
//                         <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden h-9">
//                           <button
//                             onClick={() => updateQuantity(item.productId, Math.max(1, item.quantity - 1))}
//                             className="px-3 bg-gray-50 hover:bg-gray-100 text-gray-600 transition-colors"
//                           >
//                             -
//                           </button>
//                           <span className="px-4 font-semibold text-gray-700 min-w-[40px] text-center">
//                             {item.quantity}
//                           </span>
//                           <button
//                             onClick={() => updateQuantity(item.productId, item.quantity + 1)}
//                             className="px-3 bg-gray-50 hover:bg-gray-100 text-gray-600 transition-colors"
//                           >
//                             +
//                           </button>
//                         </div>

//                         <button
//                           onClick={() => removeFromCart(item.productId)}
//                           className="flex items-center gap-1 text-red-500 hover:text-red-600 font-medium text-sm p-2"
//                         >
//                           <Trash2 size={18} />
//                           <span className="hidden sm:inline">Remove</span>
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Right Column: Price Summary */}
//         <div className="lg:col-span-1">
//           <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 h-fit sticky top-24">
//             <h2 className="font-bold text-lg text-gray-800 mb-4">Price Details</h2>
//             <div className="space-y-3 text-gray-600">
//               <div className="flex justify-between">
//                 <span>Price ({cart.length} items)</span>
//                 <span className="text-gray-900">₹{totalProductPrice.toFixed(2)}</span>
//               </div>
//               <div className="flex justify-between text-emerald-600 font-medium">
//                 <span>Discount</span>
//                 <span>-₹{discount.toFixed(2)}</span>
//               </div>

//               <div className="text-xl font-bold flex justify-between mt-4 border-t pt-4 text-gray-900">
//                 <span>Order Total</span>
//                 <span>₹{grandTotal.toFixed(2)}</span>
//               </div>

//               <div className="mt-4 p-3 bg-emerald-50 text-emerald-700 rounded-lg text-sm flex items-center gap-2 border border-emerald-100">
//                 <CheckCircle size={18} /> 
//                 <span>Yay! You saved ₹{discount.toFixed(2)} on this order</span>
//               </div>

//               <p className="text-[11px] text-gray-400 text-center mt-4 uppercase tracking-wider">
//                 Safe and Secure Payments
//               </p>

//               <button
//                 onClick={handleContinueToCheckout}
//                 className="w-full mt-4 py-3.5 bg-purple-600 hover:bg-purple-700 text-white rounded-xl font-bold flex items-center justify-center gap-2 shadow-lg shadow-purple-100 transition-all active:scale-95"
//               >
//                 <ShoppingCart size={20} /> Continue to Checkout
//               </button>
              
//               <p className="text-center text-xs text-gray-500 mt-2">
//                 Easy Returns • 100% Authentic
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CartPage;



import React, { useState } from 'react';
import { useCart } from "../Header/CartContext";
import { useNavigate } from "react-router-dom";
import { Trash2, CheckCircle, ShoppingCart } from "lucide-react";
import AuthModal from "../Header/AuthModal"; // ✅ Import AuthModal

const CartPage = () => {
  const { cart, updateQuantity, removeFromCart } = useCart();
  const navigate = useNavigate();
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false); // ✅ State for Modal

  const discount = 10;
  const totalProductPrice = cart.reduce((acc, item) => acc + item.price * item.quantity, 0);
  const grandTotal = totalProductPrice - discount;

  const handleContinueToCheckout = () => {
    const token = localStorage.getItem("token");

    if (token) {
      // User is logged in, proceed to checkout
      localStorage.removeItem('buyNowProduct');
      localStorage.removeItem('checkoutMode');
      navigate("/checkoutpage");
    } else {
      // User is guest, show login modal
      setIsAuthModalOpen(true);
    }
  };

  // ✅ Handle Login Success inside Modal
  const handleLoginSuccess = (user: any) => {
    // Context will automatically sync the cart due to the 'storage' or 'loginSuccess' event
    // We just close the modal and navigate
    setIsAuthModalOpen(false);
    
    // Slight delay to allow cart sync to happen before navigation
    setTimeout(() => {
        navigate("/checkoutpage");
    }, 500);
  };

  if (cart.length === 0) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center text-center p-8"> 
        <img src="/empty.jpg" alt="Empty Cart" className="w-60 mb-6" />
        <h2 className="text-3xl font-semibold text-gray-800">
          Your Cart is <span className="text-red-500">Empty!</span>
        </h2>
        <button
          onClick={() => navigate('/')}
          className="mt-6 bg-purple-600 text-white px-8 py-3 rounded-lg text-xl font-semibold hover:bg-purple-700 transition-colors shadow-lg"
        >
          Start Shopping
        </button>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4 md:p-8 min-h-screen bg-gray-50">
      
     {/* ✅ Login Modal Triggered here if Guest tries to Checkout */}
{isAuthModalOpen && (
  <AuthModal 
    onClose={() => setIsAuthModalOpen(false)} 
    onLoginSuccess={handleLoginSuccess} // <--- Yahan 'onGoogleLogin' ki jagah 'onLoginSuccess' likhein
  />
)}

      <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">Your Shopping Cart</h1>
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Left Column: Cart Items */}
        <div className="lg:col-span-2 space-y-4">
          <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm border border-gray-100">
            <h2 className="text-lg font-bold text-gray-800 mb-4">Items in your cart</h2>
            
            <div className="divide-y divide-gray-100">
              {cart.map((item) => (
                <div key={item.productId} className="py-6 first:pt-0 last:pb-0">
                  {/* Item Layout */}
                  <div className="flex flex-col sm:flex-row gap-4">
                    {/* Image Section */}
                    <div className="w-full sm:w-32 h-32 flex-shrink-0">
                      <img
                        src={item.imageUrl || '/Logo/default-product.png'}
                        alt={item.productName}
                        className="w-full h-full object-contain rounded-lg border border-gray-50"
                      />
                    </div>

                    {/* Content Section */}
                    <div className="flex-grow flex flex-col justify-between">
                      <div>
                        <h3 className="text-base md:text-lg font-medium text-gray-900 leading-tight">
                          {item.productName}
                        </h3>
                        <p className="text-sm text-gray-500 mt-1">Seller: {item.seller || 'N/A'}</p>
                        <p className="text-lg font-bold text-gray-800 mt-2">₹{item.price.toFixed(2)}</p>
                      </div>

                      {/* Controls Section */}
                      <div className="flex items-center justify-between mt-4 sm:mt-0">
                        <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden h-9">
                          <button
                            onClick={() => updateQuantity(item.productId, Math.max(1, item.quantity - 1))}
                            className="px-3 bg-gray-50 hover:bg-gray-100 text-gray-600 transition-colors"
                          >
                            -
                          </button>
                          <span className="px-4 font-semibold text-gray-700 min-w-[40px] text-center">
                            {item.quantity}
                          </span>
                          <button
                            onClick={() => updateQuantity(item.productId, item.quantity + 1)}
                            className="px-3 bg-gray-50 hover:bg-gray-100 text-gray-600 transition-colors"
                          >
                            +
                          </button>
                        </div>

                        <button
                          onClick={() => removeFromCart(item.productId)}
                          className="flex items-center gap-1 text-red-500 hover:text-red-600 font-medium text-sm p-2"
                        >
                          <Trash2 size={18} />
                          <span className="hidden sm:inline">Remove</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right Column: Price Summary */}
        <div className="lg:col-span-1">
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 h-fit sticky top-24">
            <h2 className="font-bold text-lg text-gray-800 mb-4">Price Details</h2>
            <div className="space-y-3 text-gray-600">
              <div className="flex justify-between">
                <span>Price ({cart.length} items)</span>
                <span className="text-gray-900">₹{totalProductPrice.toFixed(2)}</span>
              </div>
              <div className="flex justify-between text-emerald-600 font-medium">
                <span>Discount</span>
                <span>-₹{discount.toFixed(2)}</span>
              </div>

              <div className="text-xl font-bold flex justify-between mt-4 border-t pt-4 text-gray-900">
                <span>Order Total</span>
                <span>₹{grandTotal.toFixed(2)}</span>
              </div>

              <div className="mt-4 p-3 bg-emerald-50 text-emerald-700 rounded-lg text-sm flex items-center gap-2 border border-emerald-100">
                <CheckCircle size={18} /> 
                <span>Yay! You saved ₹{discount.toFixed(2)} on this order</span>
              </div>

              <p className="text-[11px] text-gray-400 text-center mt-4 uppercase tracking-wider">
                Safe and Secure Payments
              </p>

              {/* ✅ Updated Button Handler */}
              <button
                onClick={handleContinueToCheckout}
                className="w-full mt-4 py-3.5 bg-purple-600 hover:bg-purple-700 text-white rounded-xl font-bold flex items-center justify-center gap-2 shadow-lg shadow-purple-100 transition-all active:scale-95"
              >
                <ShoppingCart size={20} /> 
                {localStorage.getItem('token') ? "Continue to Checkout" : "Continue to Checkout"}
              </button>
              
              <p className="text-center text-xs text-gray-500 mt-2">
                Easy Returns • 100% Authentic
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;